import { useEffect } from 'react';

import platformShortcut from '@app/utils/platformShortcut';

const useCmdEnterKeyPress = (disabled: boolean, callBack: () => void) => {
    useEffect(() => {
        if (disabled) {
            return undefined;
        }

        const submitOnCmdEnter = (e: KeyboardEvent) => {
            const cmdPlusEnterPressed = (e.metaKey || e.ctrlKey) && e.code === 'Enter';

            if (!cmdPlusEnterPressed) {
                return;
            }

            callBack();
        };

        document.addEventListener('keydown', submitOnCmdEnter);

        return () => document.removeEventListener('keydown', submitOnCmdEnter);
    }, [disabled, callBack]);

    return platformShortcut('{meta}{enter}');
};

export default useCmdEnterKeyPress;
